import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useT } from '../i18n';
import { LEXI_ENABLED } from '../lib/features';
import { Link } from 'react-router-dom';

const HomepageLexi = () => {
  const { t } = useT();
  const CHIPS = [
    { id: 'pick-stream',  labelK: 'lexi_home.chip_pick_stream',
      prompt: "I'm in 10th and confused between MPC, BiPC and Commerce. Walk me through how to pick the right one — based on my actual interests, not parental pressure." },
    { id: 'btech-spec',   labelK: 'lexi_home.chip_btech_spec',
      prompt: "I'm choosing a B.Tech specialization in 2026. Which ones are AI-resistant for the next 5–8 years in India? Give me 3 honest options." },
    { id: 'switch-now',   labelK: 'lexi_home.chip_switch_now',
      prompt: "I'm working in IT and want to switch to product or AI-related roles. Where do I start, and what's the realistic timeline?" },
  ];

  const launch = (chip) => {
    try {
      window.dispatchEvent(new CustomEvent('lxt:lexi:open', { detail: { prefill: chip.prompt } }));
    } catch (_) { /* noop */ }
  };

  if (!LEXI_ENABLED) return null;

  return (
    <section
      className="px-4 md:px-6 py-12 md:py-14 bg-gradient-to-br from-gray-900 via-slate-900 to-teal-950 text-white"
      data-testid="homepage-lexi-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-7">
          <div>
            <span className="inline-flex items-center gap-1.5 text-[10px] font-extrabold tracking-widest uppercase bg-white/10 backdrop-blur border border-white/20 px-3 py-1 rounded-full">
              <Sparkles size={11} /> {t('lexi_home.pill')}
            </span>
            <h2 className="text-2xl md:text-4xl font-black leading-[1.1] tracking-tight mt-3 max-w-2xl" data-testid="homepage-lexi-headline">
              {t('lexi_home.headline_top')} <span className="text-teal-300">{t('lexi_home.headline_em')}</span>
            </h2>
            <p className="text-sm md:text-base text-white/70 mt-3 max-w-2xl leading-relaxed">
              {t('lexi_home.sub')}
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-3" data-testid="homepage-lexi-chips">
          {CHIPS.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => launch(c)}
              data-testid={`homepage-lexi-chip-${c.id}`}
              className="group text-left bg-white/5 hover:bg-white/10 border border-white/15 hover:border-teal-400 rounded-2xl p-5 transition-colors backdrop-blur"
            >
              <span className="text-[10px] font-extrabold tracking-widest uppercase text-teal-300">Prompt</span>
              <p className="text-[15px] font-bold text-white mt-2 leading-snug">{t(c.labelK)}</p>
              <div className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold text-teal-300 group-hover:text-teal-200">
                {t('lexi_home.ask_lexi')} <ArrowRight size={13} className="group-hover:translate-x-0.5 transition-transform" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomepageLexi;
